module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    attrs: {
      "name": "card"
    }
  }, [_c('bc-navbar'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "pages_maincontent"
    }
  }, [_c('a', {
    on: {
      "click": _vm.back
    }
  }, [_c('img', {
    staticClass: "back_image_button",
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "src": "/static/images/icons/black/back.png",
      "alt": "",
      "title": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "page_single layout_fullwidth_padding"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/build-a-brand-logo.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "title"
  }, [_vm._v("Are you looking to build you business?")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Let us help you with the power of a personal brand and tools that drive sales.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Get your own digital business card, just like you are using now!")]), _vm._v(" "), _c('li', [_vm._v("Communicate to your prospects with video messages and chat")]), _vm._v(" "), _c('li', [_vm._v("Recommend A Friend™ referral system to get your customer’s and friends to be an advocate for you")]), _vm._v(" "), _c('li', [_vm._v("Build-A-Brand™ personal websites")]), _vm._v(" "), _c('li', [_vm._v("Social Content and Strategy")]), _vm._v(" "), _c('li', [_vm._v("Photo/Video Customer Testimonials")]), _vm._v(" "), _c('li', [_vm._v("And so much more…")])]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.cardData.isDemoUser && !_vm.saveRequest.isActive) ? _c('input', {
    staticClass: "button form_submit",
    style: (_vm.borderStyle),
    attrs: {
      "type": "button",
      "value": "Learn More"
    },
    on: {
      "click": _vm.submit
    }
  }) : _vm._e(), _vm._v(" "), (_vm.saveRequest.isActive) ? _c('div', {
    staticClass: "loader"
  }, [(!_vm.saveRequest.isSuccess) ? _c('looping-rhombuses-spinner', {
    attrs: {
      "animation-duration": 2500,
      "rhombus-size": 15,
      "color": _vm.spinnerColor
    }
  }) : _vm._e(), _vm._v(" "), (_vm.saveRequest.isSuccess) ? _c('div', {
    staticClass: "success_msg"
  }, [_c('img', {
    staticClass: "success_icon",
    attrs: {
      "src": "/static/images/icons/black/success.png",
      "alt": "",
      "title": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Request sent!")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("Visit us a "), _c('a', {
    on: {
      "click": _vm.onVisitClick
    }
  }, [_vm._v("www.BuildaBrand.com")])])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3d5741bf", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d5741bf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/card.vue
// module id = 765
// module chunks = 0